
import { useState } from 'react';
import MapMarkers from './MapMarkers';
import { Dialog, DialogContent } from '@mui/material';

export default function Address({ address }) {

   const [ showMap, setShowMap ] = useState(false);

   const text = address.text || address;
   const gps = address.gps;

   return <>
      <div
         className={`italic ${gps ? 'underline cursor-pointer' : ''}`}
         onClick={gps ? () => setShowMap(true) : undefined}
      >
         {text}
      </div>
      {
         showMap && <Dialog open onClose={() => setShowMap(false)}>
            <DialogContent className='p-0'>
               <div className='max-w-full w-[600px]'>
                  <MapMarkers
                     markers={[{ location: gps, caption: text }]}
                     height={600}
                  />
               </div>
            </DialogContent>
         </Dialog>
      }
   </>
}